<script lang="ts">
	import type { ConfigsEntity } from '$lib/api/restApi';
	import { onMount } from 'svelte';

	export let configs: ConfigsEntity[];

	const twitterInit = configs
		.map((config) => `twq('init', '${config.values?.tracking_id || ''}')`)
		.join(';');

	onMount(() => {
		// Hack to get the script to run after mount
		let twitterUniversal = document.getElementById('twitterUniversal');
		if (twitterUniversal) {
			twitterUniversal.innerText = `!(function (e, t, n, s, u, a) {e.twq || ((s = e.twq = function () { s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);}),(s.version = '1.1'),(s.queue = []),(u = t.createElement(n)),(u.async = !0),(u.src = '//static.ads-twitter.com/uwt.js'),(a = t.getElementsByTagName(n)[0]),a.parentNode.insertBefore(u, a));})(window, document, 'script');
			${twitterInit};
			twq('track', 'PageView');`;
		}
	});
</script>

<svelte:head>
	<script id="twitterUniversal"></script>
</svelte:head>
